/* ==============================================
   SCALPIA — Landing Page JS
   assets/scalpia-lp.js
   ============================================== */
(function () {
  'use strict';

  /* ---- Hero image gallery ---- */
  window.scalpiaSetMainImage = function (thumb) {
    var main = document.getElementById('scalpia-main-img');
    if (!main || !thumb.dataset.src) return;
    main.src = thumb.dataset.src;
    document.querySelectorAll('.sc-hero-thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  };

  /* ---- Variant selection (syncs every selector + hidden COD form + price display) ---- */
  window.scalpiaSelectVariant = function (radio) {
    var id = radio.value;
    document.querySelectorAll('#scalpia-variant-id').forEach(function (input) { input.value = id; });
    document.querySelectorAll('.sc-variant-card').forEach(function (card) {
      card.classList.toggle('is-selected', card.dataset.variantId === id);
    });
    document.querySelectorAll('.sc-variant-radio').forEach(function (r) {
      r.checked = (r.value === id);
    });
    // update standalone price display
    var card = radio.closest('.sc-variant-card');
    if (card) {
      var nowEl = document.getElementById('sc-hero-price-now');
      var wasEl = document.getElementById('sc-hero-price-was');
      if (nowEl && card.dataset.price) nowEl.textContent = card.dataset.price;
      if (wasEl) {
        if (card.dataset.hasCompare === 'true' && card.dataset.compare) {
          wasEl.textContent = card.dataset.compare;
          wasEl.style.display = '';
        } else {
          wasEl.style.display = 'none';
        }
      }
    }
  };

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll('.sc-faq__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.sc-faq__btn').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var a = other.nextElementSibling;
          if (a) a.classList.remove('is-open');
        });
        if (!expanded) {
          btn.setAttribute('aria-expanded', 'true');
          var ans = btn.nextElementSibling;
          if (ans) ans.classList.add('is-open');
        }
      });
    });
  }

  /* ---- Generic accordion (hero/product details style) ---- */
  function initAccordion() {
    document.querySelectorAll('.sc-acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = btn.nextElementSibling;
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---- Smooth scroll for in-page CTAs ---- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#scalpia"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---- Releasit COD embed: style the submit button ----
     Releasit renders this button with inline style="... !important" attributes set
     by its own script, so an external stylesheet !important can never win (inline
     specificity always beats it). The only way to change it is to overwrite those
     same inline properties via JS after the app injects the button. */
  function initCodEmbedButton() {
    var wrap = document.getElementById('scalpia-cod-embed');
    if (!wrap) return;

    function styleButton(btn) {
      if (!btn || btn.dataset.scStyled) return;
      btn.dataset.scStyled = 'true';
      btn.style.setProperty('background', '#B73164', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('border-radius', '999px', 'important');
      btn.style.setProperty('box-shadow', 'none', 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('font-size', '19px', 'important');
      btn.style.setProperty('font-weight', '800', 'important');
      btn.style.setProperty('padding', '18px 24px', 'important');
      btn.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('letter-spacing', '0.02em', 'important');
    }

    function scan() {
      wrap.querySelectorAll('._rsi-modal-submit-button').forEach(styleButton);
    }

    scan();
    new MutationObserver(scan).observe(wrap, { childList: true, subtree: true });
  }

  function init() {
    initFaq();
    initAccordion();
    initSmoothScroll();
    initCodEmbedButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
